var React = require('react');

function CloseOutline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close"),React.createElement("line",{"x1":"368","y1":"368","x2":"144","y2":"144","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":1}),React.createElement("line",{"x1":"368","y1":"144","x2":"144","y2":"368","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32px"},"key":2})]);
}

CloseOutline.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = CloseOutline;

CloseOutline.default = CloseOutline;
